import { useContext } from 'react';

import { PresetsContext } from 'components/Presets/PresetsContext';

import { useChildComponent } from '@gogame/hooks-ts';
import { useScreenModalV2 } from '@gogame/screens';

import PresetFormDialog, { CreatePresetForm } from '../PresetForm';
import { useCreatePreset as useCreatePresetMutation } from '../data';

export const useCreatePreset = ({
  presetKey,
  isAddPresetWithGroup,
  screenData,
  titleDialogAdd,
}) => {
  const [childComponent, showChildComponent] = useChildComponent();
  const [createPreset] = useCreatePresetMutation(presetKey);
  const { onApply } = useContext(PresetsContext);

  const showModal = useScreenModalV2(PresetFormDialog);

  const handleSubmit = async ({ group, ...newPreset }) => {
    //"Ungrouped" group id is 0
    if (group && group.id !== 0) {
      newPreset.group = group;
    }

    return await createPreset(newPreset);
  };

  const handleAddPreset = async (
    initialValues = {
      group: { id: 0, name: 'Ungrouped' },
      data: screenData,
    }
  ) => {
    const preset = isAddPresetWithGroup
      ? await new Promise((resolve) =>
          showChildComponent(CreatePresetForm, {
            initialValues: initialValues,
            presetKey,
            onSubmit: resolve,
          })
        )
      : await showModal({
          title: titleDialogAdd || 'Add Preset',
          initialValues: { title: '', data: screenData },
        });
    const newPreset = await handleSubmit(preset);

    await onApply({ preset: newPreset, applyPresetData: false });
  };

  return [childComponent, handleAddPreset];
};
